export const MAX_ORDERABLE_QUANTITY = 99999;

const WHOLE_NUMBER = /^\d+$/;

export function isOrderableQuantity(quantity: string): boolean {
    return WHOLE_NUMBER.test(quantity) && Number(quantity) >= 1 && Number(quantity) <= MAX_ORDERABLE_QUANTITY;
}
